export default "__VITE_ASSET___app/immutable/assets/modal-logo-dark-background.CjFn2CQh.svg__"